// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fills Ant Content so overflow stays on inner dashboard body, not the page chrome */
.dashboard-route-shell {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-self: stretch;
  width: 100%;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  position: relative;
  z-index: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/TableauDashboard/dashboardRouteShell.scss"],"names":[],"mappings":"AAAA,qFAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AACF","sourcesContent":["/* Fills Ant Content so overflow stays on inner dashboard body, not the page chrome */\n.dashboard-route-shell {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  align-self: stretch;\n  width: 100%;\n  min-height: 0;\n  height: 100%;\n  max-height: 100%;\n  overflow: hidden;\n  position: relative;\n  z-index: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
